import {z} from '@hono/zod-openapi';

import {amount} from './amount';

export const ArticleStockAgingBucketSchema = z
  .object({
    bucket: z.enum(['months0to3', 'months3to6', 'months6to12', 'months12to24', 'months24plus']),
    quantity: amount.nullable(),
    purchaseValue: amount.nullable(),
    sharePercent: amount.nullable(),
    isComplete: z.boolean(),
  })
  .openapi('ArticleStockAgingBucket');

export type ArticleStockAgingBucket = z.infer<typeof ArticleStockAgingBucketSchema>;
